import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
          <img alt={'logo'} className={'logo-img'} src={'./logo.png'}/>
          <div className="container">
              <div className="container-text">
                  <p className={'title'}>Start with a city and grow your empire!</p>
                  <p className={'description'}>Begin with a single city and expand your influence across the land. Build, trade, conquer, and strategize your way to a thriving empire that stands the test of time.</p>
              </div>
              <img alt={'preview'} className={'preview-img'} src={'./screenshot-1.png'}/>
              <div className="container-text">
                  <p className={'title'}>Use resources & tokens to create buildings.</p>
                  <p className={'description'}>Collect resources and strategically use tokens to construct a variety of buildings. Each structure unlocks new abilities, boosts your progress, and brings you one step closer to mastering the game world.</p>
              </div>
              <img alt={'preview'} className={'preview-img'} src={'./screenshot-3.png'}/>
          </div>
          <Link className={'footer-text'} to="/privacy-policy">Privacy Policy</Link>
      </header>
    </div>
  );
}

export default App;
